<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    fullscreen
    v-if="location != null"
>
    <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Curbside Settings: {{location.internal_label}}<span style="margin-left: 7px;">(<v-icon>mdi-alpha</v-icon>)</span></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="onClickDiscard"
            >
              Discard Changes
            </v-btn>

            <v-btn
              dark
              text
              @click="onClickSave"
              :disabled="!is_valid"
            >
              Save &amp; Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

            <v-switch
                v-model="location.curbside_settings.location_offers_curbside_pickup"
                label="Offer Curbside Pickup"
            />

            <div
                v-if="location.curbside_settings.location_offers_curbside_pickup"
            >
                <h1><b>Required:</b> "Customer Arrived" Notification Plan</h1>

                <m-notification-plan
                    label="RedChirp will notify you when a customer has arrived. Tell us who to notify to find someone to fulfill the pickup."
                    v-model="location.curbside_settings.notification_plan"
                    :organization_id="location.organization_id"
                    style="margin-bottom: 25px;"
                />

                <h1><b>Optional:</b> "Pickup Created" Notification Plan</h1>

                <h2
                    style="margin-bottom: 15px;"
                >
                  RedChirp can also notify you when a pickup is first created. Tell us who to notify to find someone to prepare the pickup.
                </h2>

                <v-radio-group v-model="location.curbside_settings.order_prep_notification_option" v-on:change="onChangeOrderPrepOption">
                    <v-radio
                        label="Do not send any notifications when a pickup is created"
                        value="no-enroute-notifications"
                    />

                    <v-radio
                        label='Use the same "Customer Arrived" Notification Plan as above'
                        value="same-notification-plan-as-arrival"
                    />

                    <v-radio
                          label="Use a different notification plan when a pickup is created"
                          value="custom-notication-plan"
                      />
                </v-radio-group>

                <m-notification-plan
                        style="margin-top: 25px;"
                        label="Notification Plan: Order Needs Prep"
                        v-if="location.curbside_settings.order_prep_notification_option == 'custom-notication-plan'"
                        v-model="location.curbside_settings.order_prep_notification_plan"
                        :organization_id="location.organization_id"
                />

                <h1><b>Optional:</b> "Customer En Route" Notification Plan</h1>

                <h2
                    style="margin-bottom: 15px;"
                >
                  RedChirp can also notify you when the customer is on the way (en route). Tell us who to notify to find someone to stage the pickup.
                </h2>

                <v-radio-group v-model="location.curbside_settings.enroute_notification_option" v-on:change="onChangeEnrouteOption">

                    <v-radio
                        label="Do not send any notifications when the customer is en route"
                        value="no-enroute-notifications"
                    />

                    <v-radio
                        label='Use the same "Customer Arrived" Notification Plan as above'
                        value="same-notification-plan-as-arrival"
                    />

                    <v-radio
                        label="Use a different notification plan when the customer is en route"
                        value="custom-notication-plan"
                    />
                </v-radio-group>

                <m-notification-plan
                    style="margin-top: 25px;"
                    label="Notification Plan: Customer En route"
                    v-if="location.curbside_settings.enroute_notification_option == 'custom-notication-plan'"
                    v-model="location.curbside_settings.enroute_notification_plan"
                    :organization_id="location.organization_id"
                />



            </div>

        </v-card-text>

        

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            is_valid: true,
            location: null,
        }
    },

    methods: {

        showDialog(location)
        {
            this.inboxes = [];
            this.location = _.cloneDeep(location);

            this.$rc.showSpinner();
            
            this.$rc.getOrganizationProfile(
                location.organization_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.dialog = true;
                    this.$router.dialog_guard = this.dialogGuard;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get inboxes');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // The dialog is showing...
            if ( this.is_valid )
            {
                // The location is valid, so save and close the dialog (but don't proceed to the new route...)
                this.saveLocation();
                this.dialog = false;
                next(false);
                return;
            }

            this.$rc.snackbar('You must either correct the errors in this location or discard your changes.',3500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            this.closeDialog();
            this.saveLocation();
        },

        saveLocation()
        {
            this.$rc.showSpinner();
            
            this.$rc.upsertLocation(
                this.location,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Location saved',3500);

                    this.$emit('ok');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to save location');
                },
            );
        },

        onClickDiscard()
        {
            this.closeDialog();
        },

        onChangeOrderPrepOption()
        {
            if ( this.location.curbside_settings.order_prep_notification_option != 'custom-notication-plan' )
              return;

            if ( this.location.curbside_settings.order_prep_notification_plan != null )
              return;

            this.location.curbside_settings.order_prep_notification_plan = _.cloneDeep(this.location.curbside_settings.notification_plan);
        },

        onChangeEnrouteOption()
        {
            if ( this.location.curbside_settings.enroute_notification_option != 'custom-notication-plan' )
                return;

            if ( this.location.curbside_settings.enroute_notification_plan != null )
                return;

            this.location.curbside_settings.enroute_notification_plan = _.cloneDeep(this.location.curbside_settings.notification_plan);
        },
    },
}
</script>

<style lang="scss" scoped>

h1 {
    margin-bottom: 15px;
}
</style>